<template>
  <div class='animated-number'></div>
</template>

<script>
import { CountUp } from 'countup.js';

export default {
  name: 'AnimatedNumber',
  props: {
    prefix: {
      type: String,
      default: '£',
    },
    suffix: {
      type: String,
      default: '',
    },
    startVal: {
      type: Number,
      default: 0,
    },
    value: {
      type: Number,
      default: 0,
    },
    decimalPlaces: {
      type: Number,
      default: 0,
    },
    duration: {
      type: Number,
      default: 0.3,
    },
    separator: {
      type: String,
      default: ',',
    },
  },
  data() {
    return {
      countup: {},
    };
  },
  watch: {
    value(newVal) {
      this.countup.update(newVal);
    },
  },
  mounted() {
    this.countup = new CountUp(this.$el, this.value, {
      startVal: this.startVal,
      decimalPlaces: this.decimalPlaces,
      duration: this.duration,
      prefix: this.prefix,
      suffix: this.suffix,
      separator: this.separator,
    });

    this.countup.start();
  },
};
</script>

<style lang='scss'>
  .animated-number {
    display: inline-block;
  }
</style>
